import { useTranslation } from '../i18n';

/**
 *  Hook to get the contextualized locale for the plan task plugin.
 */
export const usePlanTaskLocale = (): ReturnType<typeof useTranslation> =>
  useTranslation();
